"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUser = exports.getUser = exports.createUser = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _options = require("@module/options");

var _request = _interopRequireDefault(require("@package/request"));

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var getUser = function getUser(userId) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                message: 'Получение данных пользователя: ' + userId
              });
              dispatch((0, _slice.getUserRequestAction)());
              _context.next = 5;
              return (0, _request["default"])({
                url: "/users/".concat(userId),
                method: 'get'
              });

            case 5:
              result = _context.sent;
              dispatch((0, _slice.getUserRequestSuccessAction)(result['data']));
              dispatch((0, _dialog.openDialog)('update-user', result['data']));
              _context.next = 17;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", void 0);

            case 14:
              dispatch((0, _slice.getUserRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                message: 'Ошибка при получении данных пользователя: ' + userId
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getUser = getUser;

var createUser = function createUser(formData) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var result, errorMessage;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на добавление нового пользователя'
              });
              dispatch((0, _slice.createUserRequestAction)());
              _context2.next = 5;
              return (0, _request["default"])({
                url: '/users',
                method: 'post',
                data: formData
              });

            case 5:
              result = _context2.sent;
              dispatch((0, _slice.createUserRequestSuccessAction)(result['data']));
              dispatch((0, _options.createUserRequestAction)(result['data']));
              dispatch((0, _dialog.closeDialog)('create-user'));
              dispatch(notifications.pushSuccess('Пользователь успешно создан'));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Новый пользователь успешно создан'
              });
              _context2.next = 22;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 17:
              dispatch((0, _slice.createUserRequestFailAction)(_context2.t0['data']));
              errorMessage = "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 (\u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ".concat(_context2.t0['data']['code'], ")\n    ").concat(_context2.t0['data']['message'] || '');

              if (_context2.t0['data']['code'] === '60.6.307') {
                errorMessage = "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0441 \u0442\u0430\u043A\u0438\u043C email \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 (".concat(_context2.t0['data']['code'], ")");
              }

              dispatch(notifications.push({
                title: 'Ошибка при создании пользователя',
                content: errorMessage,
                mode: 'danger',
                autoClose: false
              }));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при создании нового пользователя'
              });

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.createUser = createUser;

var updateUser = function updateUser(formData) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на обновление данных пользователя'
              });
              dispatch((0, _slice.updateUserRequestAction)());
              _context3.next = 5;
              return (0, _request["default"])({
                url: '/users/' + formData['id'],
                method: 'put',
                data: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, formData), {}, {
                  phone: formData['phone'] || null
                })
              });

            case 5:
              result = _context3.sent;
              dispatch((0, _slice.updateUserRequestSuccessAction)(result['data']));
              dispatch((0, _dialog.closeDialog)('create-user'));
              dispatch(notifications.pushSuccess('Данные пользователя успешно обновлены'));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Данные пользователя успешно обновлены'
              });
              _context3.next = 19;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);

              if (!(_context3.t0 instanceof _errors.UnauthorizedError)) {
                _context3.next = 16;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 16:
              dispatch((0, _slice.updateUserRequestFailAction)(_context3.t0['data']));
              dispatch(notifications.pushFail(_context3.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при запросе на обновление данных пользователя'
              });

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 12]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.updateUser = updateUser;